import { boostCountdown, tapBoostAt } from "../domain/tapBoost";
import type { GameState } from "../domain/types";
import type { Translator } from "../i18n/locales";
import { escapeHtml } from "./templates";

export function renderTapBoostStatus(state: GameState, now: number, t: Translator, detailed = false): string {
  const boost = tapBoostAt(state, now);
  if (!boost.active && boost.queued.length === 0) return "";
  const active = boost.active;
  const reward = new Intl.NumberFormat(state.settings.locale).format(BigInt(boost.reward));
  const title = active ? t("boost.tapActive", { percent: boost.percent }) : t("boost.tapQueued");
  const time = boostCountdown(active?.endsAt ?? boost.queued[0]!.startsAt, now);
  return `<strong>${escapeHtml(title)}<time>${escapeHtml(time)}</time></strong>
    ${active ? `<span data-live-tap-reward>${escapeHtml(t("boost.perTap", { value: reward }))}</span>` : ""}
    ${boost.queued.length ? `<small>${escapeHtml(t(detailed ? "boost.next" : "shop.queued", { count: boost.queued.length }))}</small>` : ""}
    ${detailed && boost.queued.length ? `<p>${escapeHtml(t("boost.sequential"))}</p>` : ""}`;
}
